
let good         = 'good';
let neutral      = 'neutral';
let bad          = 'bad';
let information  = 'information';
let blank        = 'blank';

// let ccr_groups = [
//   { name: 'C,A,R,P,T', codes: ['C','A','R','P','T'] },
//    {name: '0-1',       codes: ['0','1'] },
//   { name: '2',         codes: ['2'] },
//   { name: '3-6 & X',   codes: ['3','4','5','6','X'] },
// ];
let ccr_status_code_ordering = ['0','1','2','3','4','5','6','X'];

function file_ban() {
  return bad;
}

function credit_score_status(credit_score){
  if(isNaN(credit_score.v_20) || credit_score.v_20 == 0 || credit_score.v_20 == '' || credit_score.v_20 == null) return blank;
  if(credit_score.v_20 <= -997 || credit_score.v_11 <= -997) return bad;
  if(credit_score.v_20 < 500) return neutral;
  return good;
}

function credit_shopping_status(credit_shopping){
  if(credit_shopping.value != 'None') return information;
  return good;
}

function payday_enquiries_status(payday_enquiries){
  if(payday_enquiries.count == 0) return good;
  if(payday_enquiries.count > 0 && payday_enquiries.count < 3)  return neutral;
  if(payday_enquiries.count >= 3)  return bad;
}

function financial_defaults_status(financial_defaults){
  if(financial_defaults.paid_value == 0 && financial_defaults.unpaid_value == 0) return good;
  if(financial_defaults.unpaid_value >= 7500) return bad;
  return neutral;
}

function non_financial_defaults_status(non_financial_defaults){
  if(non_financial_defaults.paid_value == 0 && non_financial_defaults.unpaid_value == 0) return good;
  if(non_financial_defaults.unpaid_value >= 10000) return bad;
  return neutral;
}

function insolvency_status(insolvency){
  if(insolvency.value == 'Current') return bad;
  if(insolvency.value == 'Past') return neutral;
  return good;
}

function abn_status(abn_status) {
  switch (abn_status) {
    case 'GREEN':
      return good;
    case 'AMBER':
      return neutral;
    case 'RED':
      return bad;
    case 'NIL':
    default:
      return information;
  }
}

function ccr_status(ccr){
  // Red(bad) color, when current month ccr code > 2
  if (is_ccr_last_bad(ccr)) return bad
  //  Amber (neutral) color, when we have got V status
  if (is_ccr_consist_v_status(ccr)) return neutral

  let worst_status = ccr_worst_status(ccr);

  switch(worst_status['24m']){
    case "C": return information;
    case "A": return information;
    case "R": return information;
    case "P": return information;
    case "T": return information;
    case "0":
    case "1": return good;
    case "2":
    case "3":
    case "4":
    case "5":
    case "6":
    case "X": return neutral;
    default:  return blank;
  }
}

function ccr_worst_status(ccr){

  let all_codes = {
    '12m': new Set(),
    '24m': new Set(),
  };

  for(let account of ccr.accounts){
    for(let i = 0; i < 12; i++){
      all_codes['24m'].add(account.repayment_history[i]);
    }
    for(let i = 12; i < 24; i++){
      all_codes['24m'].add(account.repayment_history[i]);
      all_codes['12m'].add(account.repayment_history[i]);
    }
  }

  let worst_status = {
    '12m': ccr_status_code_ordering[0],
    '24m': ccr_status_code_ordering[0],
  };

  for(let key of ccr_status_code_ordering){
    if(all_codes['12m'].has(key)){
      worst_status['12m'] = key;
    }
    if(all_codes['24m'].has(key)){
      worst_status['24m'] = key;
    }
  }

  return worst_status;

  // let worst_group = { group: '0-1', value: 0 };
  // let groups = {};

  // for(let { name,codes } of ccr_groups){
  //   let sum = codes.map(key => ccr.count_by_code[key]).reduce( (a,b)=>a+b, 0);
  //   groups[name] = sum;

  //   if(sum > 0){
  //     worst_group = { group: name, value: sum }
  //   }
  // }

  // return {
  //   worst_status,
  //   worst_group,
  //   groups,
  // };
}

function is_ccr_last_bad(ccr) {
  let end_year, end_month_with_zero;
  if (ccr.reporting_end) {
    [end_year, end_month_with_zero] = ccr.reporting_end.split('-');

    let date = new Date();
    let year = date.getFullYear().toString();
    let month = (date.getMonth()+1).toString();
    let end_month = end_month_with_zero.replace(/^0+/, '');

    if (month == end_month && year == end_year) {
      for (let account of ccr.accounts) {
        let lastStatus = parseInt(account.repayment_history[account.repayment_history.length-1]);
        if(!isNaN(lastStatus) && lastStatus > 2) {
          return true;
        }
      }
    }
  }
  return false;
}

function is_ccr_consist_v_status(ccr) {
  for (let account of ccr.accounts) {
    if (account.repayment_history_v_status != null && account.repayment_history_v_status.length > 0) {
      account.repayment_history_v_status.forEach(element => {
        if (element && element.data_field_value && element.data_field_value.toLowerCase === 'v') {
          return true;
        }
      });
    }
  }
  return false;
}

function ccr_dates(ccr){
  // get date range from payload if ccr data is available, otherwise year and month values remain empty and an empty table us rendered
  let start_year, start_month, end_year, end_month;
  if (ccr.reporting_start && ccr.reporting_end) {
    [start_year, start_month] = ccr.reporting_start.split('-');
    [end_year, end_month] = ccr.reporting_end.split('-');
  }

  // defaine start and end dates
  let start = { year:Number(start_year), month:Number(start_month) };
  let end =   { year:Number(end_year),   month:Number(end_month) };
  // computes a total number of months to numerically compare dates
  let total_months = ({ year, month }) => year*12+month;

  let years = [];
  for(let now = start; total_months(now) <= total_months(end);){

    // string representation of months with leading 0
    let month = now.month > 9 ? now.month : `0${now.month}`;

    // if first month in year or first at all, create new year entry
    if(now.month == 1 || years.length == 0) years.push({ year: now.year, months: [month] });
    // else add this month to last year in array
    else             years[years.length-1].months.push(month);

    // increment now by 1 month, with year rollover after 12 months
    if(now.month == 12) now = { year:now.year+1, month:1 };
    else                now = { year:now.year,   month:now.month+1 };
  }

  return years;
}

function fhis_dates(ccr){
  // get date range from payload if ccr data is available, otherwise year and month values remain empty and an empty table us rendered
  let start_year, start_month, end_year, end_month;
  if (ccr.reporting_start && ccr.reporting_end) {
    [start_year, start_month] = ccr.reporting_start.split('-');
    [end_year, end_month] = ccr.reporting_end.split('-');
  }

  // define start and end dates
  let start = { year:Number(start_year), month:Number(start_month) };
  let end =   { year:Number(end_year),   month:Number(end_month) };

  // computes a total number of months to numerically compare dates
  let total_months = ({ year, month }) => year*12+month;

  let years = [];
  for(let now = start; total_months(now) <= total_months(end);){
     // string representation of months with leading 0
     let month = now.month > 9 ? now.month : `0${now.month}`;

     // if first month in year or first at all, create new year entry
     if(now.month == 1 || years.length == 0) years.push({ year: now.year, months: [month] });
     // else add this month to last year in array
     else             years[years.length-1].months.push(month);

     // increment now by 1 month, with year rollover after 12 months
     if(now.month == 12) now = { year:now.year+1, month:1 };
     else                now = { year:now.year,   month:now.month+1 };
  }

  // Get all months as flat array, then take last 12
  let allMonths = [];
  years.forEach(year => {
    year.months.forEach(month => {
      allMonths.push({ year: year.year, month: month });
    });
  });

  // Take last 12 months
  let last12Months = allMonths.slice(-12);

  // Rebuild years structure from last 12 months
  let result = [];
  last12Months.forEach(item => {
    let existingYear = result.find(y => y.year === item.year);
    if (existingYear) {
      existingYear.months.push(item.month);
    } else {
      result.push({ year: item.year, months: [item.month] });
    }
  });

  return result;
}

function judgement_status(judgements){
  if(judgements.unpaid_count > 0)
    return neutral;
  if(judgements.total_count > 1)
    return neutral;
  if(judgements.total_count > 0)
    return neutral;
  return good;
}

function directorships_status(directorships) {
  return information;
}

function fhis_status(fhis, description = false) {
  // Early return if no valid data
  if (!fhis?.data?.length) {
    return null;
  }

  // Extract values using find() instead of forEach
  const getValue = (name) => fhis.data.find(fhi => fhi.name === name)?.value;

  const CX5000_ac_fhi_12m = getValue('CX5000_ac_fhi_12m');
  const CX5010_ac_fhi_0m = getValue('CX5010_ac_fhi_0m');

  // Status mapping for cleaner logic
  const statusMap = {
    // If CX5000_ac_fhi_12m is N AND CX5010_ac_fhi_0m is N
    // then Financial Hardship card result is “No Hardship Evident” and card is Green
    'N,N': { description: 'No', status: good },
    // If CX5000_ac_fhi_12m is Y AND CX5010_ac_fhi_0m is N
    // then Financial Hardship card result is “Previous Hardship Evident” and card is Orange
    'Y,N': { description: 'Previous', status: neutral },
    // If CX5000_ac_fhi_12m is Y AND CX5010_ac_fhi_0m is Y
    // then Financial Hardship card result is “Current Hardship Evident” and card is Red
    'Y,Y': { description: 'Current', status: bad }
  };

  const key = `${CX5000_ac_fhi_12m},${CX5010_ac_fhi_0m}`;
  const result = statusMap[key];

  return result ? (description ? result.description : result.status) : null;
}

function age_of_file_status(vedaReport) {
  if (vedaReport.age_of_file.months !== null) {
    let applicantAge = vedaReport.applicant_age.months - 276;
    if (applicantAge > vedaReport.age_of_file.months) {
      return neutral;
    }
  }
  return information;
}

function check_veda_green_status(vedaReport) {
  return  credit_score_status(vedaReport.credit_score) === good &&
    insolvency_status(vedaReport.insolvency) === good &&
    payday_enquiries_status(vedaReport.payday_enquiries) === good &&
    financial_defaults_status(vedaReport.financial_defaults) === good &&
    non_financial_defaults_status(vedaReport.non_financial_defaults) === good &&
    judgement_status(vedaReport.judgements) === good &&
    ccr_status(vedaReport.ccr) === good
}

export default {
  file_ban,
  credit_score_status,
  credit_shopping_status,
  payday_enquiries_status,
  financial_defaults_status,
  non_financial_defaults_status,
  insolvency_status,
  ccr_status,
  ccr_worst_status,
  ccr_dates,
  fhis_dates,
  judgement_status,
  abn_status,
  directorships_status,
  fhis_status,
  age_of_file_status,
  check_veda_green_status,
};
